import {secured as axios} from "../../../axios";
import  {useParams} from "react-router-dom";

class AdviceQuery {

    static url = '/advice'

    static async findAll()
    {
        return await axios.get(this.url)
            .then(res => {
                return res.data.map( advice => {
                        const imageUrl = process.env.REACT_APP_DEV_HOST + '/assets/img/advice3.png'
                        return {
                            ...advice,
                            title: advice.title.text,
                            image: imageUrl,
                            presentation: advice.type,
                            isFavorite: advice.isFavorite,
                            treading: false,
                            variant: "advice",
                            variantName: "Conseil",
                            description: advice.description,
                            tags: advice.tags
                        }
                    })
            })
    }

    static async findByCategory(id, categoryId)
    {
        return await axios.get(`${id}/${categoryId}/advice`)
            .then(res => {
                return res.data.map( advice => {
                    const imageUrl = process.env.REACT_APP_DEV_HOST + '/assets/img/advice3.png'
                    return {
                        ...advice,
                        title: advice.title.text,
                        image: imageUrl,
                        presentation: advice.type,
                        isFavorite: false,
                        treading: false,
                        variant: "advice",
                        variantName: "Conseil",
                        description: advice.description,
                        tags: advice.tags
                    }
                })
            })
    }

    static async findById(id) {
        const list = await this.findAll();
        return list.filter(advice => advice.id === id)[0];
    }

    static async addToFavorite(id) {
        return await axios.post(`/advice/${id}/favorite`);
    }

    static async removeFromFavorite(id) {
        return await axios.delete(`/advice/${id}/favorite`)
    }
}

export {AdviceQuery}
